import { getViemClients, } from "@bracket/contractor-next";
import { wagmiConfig as config, } from "@wagmiconfig";
import type { EthereumAddress, } from "@bracket/types";
import { getContractWithABI, } from "@bracket/chainography";
import { assertAllowance, } from "./assertAllowance";
import type { ContractResult, } from "./shared";


export declare type UnwrapProps = {
	vault: EthereumAddress;
	wrapper: EthereumAddress;
	amount: bigint;
}

export const unwrap = async ({
	vault,
	wrapper,
	amount,
}: UnwrapProps): Promise<ContractResult> => {

	try {

		const [ reader, writer, ] = await getViemClients({ config, });
		const [ _, abi ] = getContractWithABI("BracketWrappedVault", 1);

		await assertAllowance({
			spender: wrapper,
			token: vault,
			amount,
		});

		const { result, request, } = await reader.simulateContract({
			address: wrapper,
			abi,
			functionName: "unwrap",
			args: [
				amount,
			],
			account: writer.account,
		});

		const hash = await writer.writeContract(request);
		await reader.waitForTransactionReceipt({ hash, });
		return {
			success: true,
			hash,
		};

	}
	catch(err) {

		if(err?.cause?.cause?.code === 4001) {
			return {
				success: false,
				canceled: true,
			};
		}

		return {
			success: false,
			error: err as Error,
		};

	}

}
